import React, {createContext, useContext, useEffect, useState, useRef} from 'react';
import Spinner from '../../../../common/components/ui/Spinner';
import {useGlobalContext} from '../../../../common/components/core/GlobalContext';
import {useParams, useSearchParams} from "react-router-dom";

export type PaypalPaymentStatusContext = {
  status: string,
}

export type PaypalPaymentStatusContextProviderProps = {
  children: React.ReactNode,
}

export const defaultContext: PaypalPaymentStatusContext = {
  status: '',
};

export const PaypalPaymentStatusContext = createContext<PaypalPaymentStatusContext>(defaultContext);
PaypalPaymentStatusContext.displayName = 'PaypalPaymentStatusContext';

export const usePaypalPaymentStatusContext = () => useContext(PaypalPaymentStatusContext);

export const PaypalPaymentStatusContextProvider = ({children}: PaypalPaymentStatusContextProviderProps) => {
  const {status} = useParams();
  const [searchParams] = useSearchParams();
  const id = searchParams.get("token") as string;

  const getStatus = () => {
    if (status === 'success') return 'success';
    if (status === 'cancel') return 'cancel';

    return '';
  };

  const {apiService} = useGlobalContext();

  const [loading, setLoading] = useState(true);

  const hasCapturedRef = useRef(false);

  useEffect(() => {
    setLoading(true);
    const capturePayment = async () => {
      if (hasCapturedRef.current) return;

      hasCapturedRef.current = true;

      try {
        await apiService.capturePaypalPayment(id);
      } catch (e) {
        hasCapturedRef.current = false;
      } finally {
        setTimeout(() => {setLoading(false)}, 2000)
      }
    };

    capturePayment();
  }, [id]);

  const context: PaypalPaymentStatusContext = {
    status: getStatus()
  };

  return loading
    ? <Spinner/>
    : (
      <PaypalPaymentStatusContext.Provider value={context}>
        {children}
      </PaypalPaymentStatusContext.Provider>
    );
};
